export default __webpack_public_path__ + "static/media/volkswagen.79a53557.svg";